import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  const packages = [
    {
      name: 'Silver',
      price: 'R600/month',
      color: '#C0C0C0',
      gradient: 'linear-gradient(135deg, #E8E8E8 0%, #BFBFBF 50%, #A8A8A8 100%)',
      benefits: [
        'Premium Services',
        'VIP Access',
        'Priority Support'
      ],
      route: '/register/silver'
    },
    {
      name: 'Gold',
      price: 'R12,000/month',
      color: '#CDB688',
      gradient: 'linear-gradient(135deg, #CDB688 0%, #d8b261 50%, #d8b261 100%)',
      benefits: [
        'All Silver Benefits',
        'Personal Concierge',
        'Exclusive Events'
      ],
      route: '/register/gold'
    },
    {
      name: 'Platinum',
      price: 'R24,000/month',
      color: '#E5E4E2',
      gradient: 'linear-gradient(135deg, #F5F5F5 0%, #E0E0E0 50%, #C0C0C0 100%)',
      benefits: [
        'All Gold Benefits',
        'Luxury Travel',
        'Bespoke Services',
        '24/7 Support'
      ],
      route: '/register/prive'
    },
    {
      name: 'LGC',
      subtitle: 'London Gold Club',
      price: 'Contact for Pricing',
      color: '#D4AF37',
      gradient: 'linear-gradient(135deg, #F4E4A6 0%, #D4AF37 50%, #B8941F 100%)',
      benefits: [
        'All Platinum Benefits',
        'Elite Network Access',
        'Investment Advisory',
        'Ultimate Privileges'
      ],
      route: '/register/scc'
    }
  ];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? packages.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === packages.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <div className="logo-container" style={{textAlign: 'center', marginBottom: '2rem'}}>
          <img src="/images/IBVlogo.png" alt="IBV Wealth Club" style={{maxWidth: '150px', height: 'auto'}} />
        </div>

        <h2 className="page-title">Select Your Membership Tier</h2>

        <div className="carousel-container">
          <button onClick={handlePrev} className="carousel-btn carousel-btn-prev" style={{
            position: 'absolute',
            left: '5px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(0,0,0,0.6)',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            cursor: 'pointer',
            fontSize: '1.1rem',
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <i className="fas fa-chevron-left"></i>
          </button>

          <div style={{position: 'relative', padding: '1rem 60px', maxWidth: '400px', margin: '0 auto'}}>
            <div 
              className="package-card fancy-card"
              style={{
                background: packages[currentIndex].gradient,
                boxShadow: `0 8px 25px ${packages[currentIndex].color}40`,
                borderRadius: '16px',
                padding: '1.5rem',
                transition: 'all 0.5s ease'
              }}
            >
              <div className="package-header" style={{textAlign: 'center', marginBottom: '1rem'}}>
                <h3 style={{color: '#000', fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '0.25rem'}}>
                  {packages[currentIndex].name}
                </h3>
                {packages[currentIndex].subtitle && (
                  <p style={{color: '#333', fontSize: '0.75rem', marginBottom: '0.5rem', fontStyle: 'italic'}}>
                    {packages[currentIndex].subtitle}
                  </p>
                )}
                <div style={{
                  fontSize: '1.3rem',
                  fontWeight: 'bold',
                  color: '#000',
                  marginTop: '0.5rem',
                  padding: '0.6rem 1rem',
                  background: 'rgba(255,255,255,0.6)',
                  borderRadius: '10px',
                  display: 'inline-block'
                }}>
                  {packages[currentIndex].price}
                </div>
              </div>

              <div style={{marginTop: '1rem'}}>
                <h4 style={{color: '#000', marginBottom: '0.75rem', fontSize: '0.9rem', textAlign: 'center', fontWeight: '600'}}>
                  Benefits Include:
                </h4>
                <ul style={{listStyle: 'none', padding: 0}}>
                  {packages[currentIndex].benefits.map((benefit, index) => (
                    <li key={index} style={{
                      padding: '0.6rem 0.8rem',
                      marginBottom: '0.5rem',
                      background: 'rgba(255,255,255,0.5)',
                      borderRadius: '8px',
                      color: '#000',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.6rem',
                      fontSize: '0.85rem'
                    }}>
                      <i className="fas fa-check-circle" style={{color: '#000', fontSize: '0.9rem', flexShrink: 0}}></i>
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button
                onClick={() => navigate(packages[currentIndex].route)}
                style={{
                  width: '100%',
                  marginTop: '1rem',
                  padding: '0.9rem',
                  fontSize: '1rem',
                  background: '#000',
                  color: packages[currentIndex].color,
                  border: 'none',
                  borderRadius: '10px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease',
                  boxShadow: '0 3px 12px rgba(0,0,0,0.3)'
                }}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.03)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              >
                Select {packages[currentIndex].name}
              </button>
            </div>
          </div>

          <button onClick={handleNext} className="carousel-btn carousel-btn-next" style={{
            position: 'absolute',
            right: '5px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(0,0,0,0.6)',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            cursor: 'pointer',
            fontSize: '1.1rem',
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '0.5rem',
          marginTop: '1rem'
        }}>
          {packages.map((pkg, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              style={{
                width: currentIndex === index ? '2rem' : '0.7rem',
                height: '0.7rem',
                borderRadius: '1rem',
                border: 'none',
                background: currentIndex === index ? pkg.color : '#ccc',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: currentIndex === index ? `0 2px 6px ${pkg.color}60` : 'none'
              }}
            />
          ))}
        </div>

        <button 
          className="btn btn-secondary"
          onClick={() => navigate('/login')}
          style={{marginTop: '1.5rem', width: '100%', maxWidth: '400px', fontSize: '0.9rem', padding: '0.8rem'}}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default Register;
